/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

export interface Logger {
  error: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  info: (...args: any[]) => void;
}

export const createLogger = (component: string): Logger => {
  return {
    error: (...args: any[]) => {
      isEnvironmentEd() && console.error(component, ...args);
    },
    warn: (...args: any[]) => {
      isEnvironmentEd() && console.warn(component, ...args);
    },
    info: (...args: any[]) => {
      isEnvironmentEd() && console.info(component, ...args);
    },
  };
};

const isEnvironmentEd = (): boolean => {
  return process.env.REACT_APP_ENV_NAME === 'ed';
};
